export default __webpack_public_path__ + "static/media/M22.ca15f305.jpg";